/**
 * Builds the `browse_filter_applied` event fired when the /browse industry
 * chips or the "clear filters" button change the result set — see
 * Browse/index.tsx.
 *
 * Fired from an effect watching the filter state rather than from the click
 * handlers, because the count that matters is the one *after* the reducer has
 * re-filtered. A handler only knows what was clicked, not what it produced.
 */

import { getSessionId } from "./session";
import type { BrowseFilterAction, BrowseFilterAppliedEvent } from "./types";

interface BrowseFilterAppliedInput {
  action: BrowseFilterAction;
  industryIds: number[];
  query: string;
  resultCount: number;
}

export const buildBrowseFilterAppliedEvent = ({
  action,
  industryIds,
  query,
  resultCount,
}: BrowseFilterAppliedInput): BrowseFilterAppliedEvent => ({
  name: "browse_filter_applied",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: null,
  properties: {
    action,
    industry_ids: industryIds,
    query,
    result_count: resultCount,
  },
});
